import { PinchGesture } from 'react-native-gesture-handler';

import _useFrameFitting from './useFrameFitting';

export const DEFAULT_FRAME_FITTING_CONFIG: {
    enabled: boolean;
    pinchGestures: PinchGesture[] | undefined;
    frameFittingOn: boolean | undefined;
    onToggleFrameFitting: (() => void) | undefined;
    onSwitchFrameFittingOff: (() => void) | undefined;
} = {
    enabled: false,
    pinchGestures: undefined,
    frameFittingOn: undefined,
    onToggleFrameFitting: undefined,
    onSwitchFrameFittingOff: undefined,
};

function useFrameFitting(): ReturnType<typeof _useFrameFitting> {
    return DEFAULT_FRAME_FITTING_CONFIG;
}

export default useFrameFitting;
